import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

import cls from './catalog-grid-loader.module.scss'

const itemLoaderArray = Array(32).fill(null)

type CatalogGridLoaderProps = {
	isMobile: boolean
}

export const CatalogGridLoader = (props: CatalogGridLoaderProps) => (
	<div className={cls.inner}>
		{itemLoaderArray.map((_, index) => (
			<SkeletonLoader key={index} height={props?.isMobile ? 240 : 410} />
		))}
	</div>
)
